export const defaultDifficulty = 0.3

export const cutDescendantLevel = 3

export const scoreMargin = 10

export const minusScoreIfOneNodeFailed = -2

export const criterionTime = 1000 * 20

export function getScoreByRating (rating) {
  let score
  switch (rating) {
    case 'easy':
      score = 2
      break
    case 'normal':
      score = 8 / 3
      break
    case 'hard':
      score = 4
      break
    case 'fail':
      score = 30
      break
    case 'firstTime':
      score = 10
      break
    case 'reStudy':
      score = 4
      break
    case 'reTest':
      score = 4
      break
    default:
      score = 0
      // if (process.env.NODE_ENV !== 'production') {
      //   console.tron.log(`logic / 이상한 rating at getScoreByRating: ${rating} `)
      // }
      // throw (new Error('이상한 rating at getScoreByRating'))
  }
  return score
}

export const magnitudeCriteria = 32
